import { IsArray } from "class-validator";
import { Expose, Type } from "class-transformer";
import { MigrationItem } from "./MigrationItem";

export class Migrations {
  @IsArray()
  @Type(() => MigrationItem)
  @Expose()
  items: Array<MigrationItem> = [];
}
